import styled, { createGlobalStyle } from 'styled-components';

import { is, themeGet } from '../../theme/utils';

export const Overlay = styled.div<{ show: boolean }>`
  position: fixed;
  z-index: ${themeGet.zIndex('OVERLAY', 0)};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(244, 243, 242, 0.8);
  opacity: 0;
  transition: opacity 0.5s ease-out, visibility 0.5s ease-out;
  visibility: hidden;

  ${is('show')`
    opacity: 1;
    visibility: visible;
  `}
`;

export const BodyScrollLocker = createGlobalStyle<{ lock: boolean }>`
  body {
    ${is('lock')`
      overflow: hidden;
    `}
  }
`;
